<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        MY Team
      </div>
    </div>
    <div class="wrap_box">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finish-text="没有更多了"
          @load="onLoad"
        >
          <div class="list">
            <div
              v-for="(i, index) in teamList"
              :key="index"
              class="item"
            >
              <div>
                <p class="phone">
                  {{ i.phone }}
                </p>
                <p class="time">
                  {{ i.time }}
                </p>
              </div>
              <div class="level">
                {{ i.level }}
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import Vue from "vue";
import {PullRefresh , List } from "vant";
Vue.use(PullRefresh).use(List);
export default {
  name: "AllTeam",
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      listQuery: {
        page: 1,
        limit: 1000,
      },
      teamList: [],
      listLength: true,
      Langu: 'en_us',
    };
  },
  created() {
    this.$parent.footer('user',false);
    this.Langu = localStorage.getItem("lang")||"en_us";
  },
  methods: {
    // 上拉加载
    onLoad() {
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    onRefresh() {
      setTimeout(() => {
        this.listQuery.page = 1;
        this.getlist();
        this.refreshing = false;
      }, 1000);
    },
    getlist() {
      Fetch("/user/allTeam",this.listQuery).then((r) => {
        if (this.listQuery.page === 1) {
          this.teamList = r.data.list
        } else {
          r.data.list.forEach(item => {
            this.teamList.push(item)
          });
          this.loading = false
        }
        if (r.data.list.length > 0) {
          this.listQuery.page++;
          this.loading = false
        } else {
          this.finished = true
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  .item {
    width: 90%;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 10px;
    margin-bottom: 15px;
    box-shadow: 2px 2px 4px #d3d3d3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;

    .phone {
      font-size: 20px;
      margin-bottom: 10px;
    }

    .level {
      color: #e7c78a;
      font-size: 24px;
    }
  }
}
.red_top_bg{
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}
.back_left {
  background: url(../../views/images/item/back_b.png) no-repeat center center;
}
.big_tit{
  color: #000000;
}
.wrap_box {
  width: 100%;
  margin-top: 56px;
  min-height: calc(100vh - 100px);
  overflow: hidden;
}
</style>
